// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"806":"4163ae0c","2366":"1d2671aa","9509":"6f31d389"}[chunkId] || chunkId) + "." + {"806":"611492ddd6e516ab","2227":"e5aff891bcfb3c3d","2366":"3dd3a126c06b8b96","4001":"53bdfadd2d01448f","7085":"0990dc32e053d5e4","8377":"dfcd5bbe7b5bf24f","8436":"cab94b59cca0a8ff","9509":"44c8744c9bf5e75d"}[chunkId] + ".js";
};